// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7e18a059","150":"61b6ed0b","229":"0e137b28"}[chunkId] + ".chunk.js";
};